export const environment = {
  production: true,
  API_URL: '',
  ASSETS_URL: 'https://valzy.com/',
  WS_URL: "wss://valzy.com/socket",
  TOKEN_NAME: 'IV-TOKEN',
  ORDER_FORM_URL: "https://order.reliantvalue.com/",
  LOAD_CHAT: true,
  SHOW_DEBUG: false,
  IS_DEVELOPMENT: false,
  STRIPE_KEY: 'pk_live_51JZlh0Hi3MJQ8RfYbcwoknpQOToAr4TZC9KSbfgs4udL4hciOHpwIBMvsopufSMKiyKHA0MIy1kesJSsBCYr5P2F00QXxYlWFK'
};
